// "one Checkpoint", "2 Benchmarks", "unlimited full-length SATs" — the one way
// plan copy turns an allowance NUMBER into words.
//
// Dependency-free on purpose: plan-config.ts builds the pricing-card features
// with it, and plan-copy.ts (which imports PLANS) builds the prose with it, so
// it can't live in either without a cycle.

const NUMBER_WORDS = ['no', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine']

export function countPhrase(
  n: number,
  singular: string,
  opts: { plural?: string; numerals?: boolean } = {},
): string {
  const plural = opts.plural ?? `${singular}s`
  if (n === Infinity) return `unlimited ${plural}`
  const noun = n === 1 ? singular : plural
  const amount = opts.numerals && n > 0 ? String(n) : (NUMBER_WORDS[n] ?? String(n))
  return `${amount} ${noun}`
}
